<template>
  <div>
    <audio src="/audio/chime.mp3" ref="audio" preload />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { actions, getters } from "@/store";
import { ROUTE_NAMES } from "@/router/constants";

export default {
  data() {
    return {
      newIdentNotification: {
        id: "new-identification",
        title: this.$t("identification.new_ident_notification_title"),
        message: this.$t("identification.new_ident_notification_message"),
        duration: 0,
        actions: [
          {
            label: this.$t("identification.new_ident_notification_view"),
            to: { name: ROUTE_NAMES.IDENTIFICATION }
          },
          { label: "Dismiss" }
        ]
      }
    };
  },
  methods: {
    ...mapActions([actions.notificationAdd, actions.notificationDismiss]),
    notifyInactiveRoute() {
      if (!this.isIdentificationRoute) {
        this.notificationAdd(this.newIdentNotification);
      }
    },
    playNewIdentSound() {
      const { audio } = this.$refs;
      if (audio.paused) {
        audio.play?.();
      } else {
        audio.currentTime = 0;
      }
    }
  },
  computed: {
    ...mapGetters([getters.currentIdentification]),
    isIdentificationRoute() {
      return this.$route.matched.some(
        ({ name }) => name === ROUTE_NAMES.IDENTIFICATION
      );
    }
  },
  watch: {
    isIdentificationRoute() {
      if (this.isIdentificationRoute) {
        this.notificationDismiss(this.newIdentNotification);
      }
    },
    "currentIdentification.identificationId"() {
      if (this.currentIdentification?.identificationId) {
        this.playNewIdentSound();
        this.notifyInactiveRoute();
      }
    }
  }
};
</script>
